import { Platform } from 'react-native';

import { getBrowser } from './getBrowser';

export const browser = getBrowser();
export const isWeb = Platform.OS === 'web';
export const isMobileBrowser = isWeb && browser.mobile;
export const isDesktopBrowserDifferentFromChrome = isWeb && !browser.mobile && !browser.chrome;
